import { GET_SCENE_TEAM_STATISTIC } from "./actionType";

const initialState = {
  data: null
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SCENE_TEAM_STATISTIC:
      return {
        ...state,
        data: payload
      };
    default:
      return {
        ...state
      };
  }
};
